import React, { FC, useEffect, useCallback } from 'react';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { Skeleton } from 'antd';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { ListagemArquivosActions } from 'Store/ListagemArquivos/ListagemArquivos.actions';
import { IListFilesRequest } from 'Data/interfaces/ListagemArquivos/IListFilesRequest';
import { IMoveFileRequest } from 'Data/interfaces/ListagemArquivos/IMoveFileRequest';
import { Icon } from 'Components/UI';
import { GetDisciplineApiFolderIdFromBreadCrumb } from 'Utils/ObraUtils';
import { Container } from './styles';

export interface IFolderInfo {
  icon?: React.ReactNode;
  description?: string;
  href?: string;
}

export interface IMoverArquivos {
  folderId: string;
  breadCrumbId: string | null;
  fileId?: string;
  position?: {
    x: number;
    y: number;
  }
  toggleDropdown: () => void;
}

const MoverArquivos: FC<Props> = ({
  constructionSiteId,
  listagemArquivos,
  folderId,
  fileId,
  breadCrumbId,
  position,
  toggleDropdown,
}) => {
  const dispatch = useDispatch();

  const searchFolder = useCallback((folderId: string, breadCrumbId?: string | number | null) => {
    if (folderId) {
      const request: IListFilesRequest = {
        constructionSiteId: constructionSiteId || 0,
        folderId,
        onlyFolder: true
      };

      if (breadCrumbId)
        request.breadCrumbId = breadCrumbId.toString();

      dispatch(ListagemArquivosActions.listFilesMoveTo(request));
    }
  }, [dispatch, constructionSiteId]);

  useEffect(() => {
    if (!listagemArquivos.ListFilesMoveTo.isLoading) {
      searchFolder(folderId, breadCrumbId);
    }
  }, []);

  const moveFiles = () => {

    if (listagemArquivos.BreadCrumbItem.Identifier !== listagemArquivos.ListFilesMoveTo.BreadCrumbItem?.Identifier) {

      const filesId = fileId ? [fileId] : listagemArquivos.selectedEditRowKeys;

      const request: IMoveFileRequest = {
        ConstructionSiteId: constructionSiteId || 0,
        CurrentFolderId: listagemArquivos.BreadCrumbItem.Identifier,
        FilesId: filesId,
        NewFolderId: listagemArquivos.ListFilesMoveTo.BreadCrumbItem?.Identifier || '',
        DisciplineApiFolderId: GetDisciplineApiFolderIdFromBreadCrumb(listagemArquivos.BreadCrumbItem),
        FileRenames: {},
      };

      dispatch(ListagemArquivosActions.moveFile(request));
      toggleDropdown();
    }
  };

  return (
    <Container position={position}>
      <div className="header" >
        {
          listagemArquivos.ListFilesMoveTo.isLoading
            ? <div className="skeletonTitle" >
              <Skeleton paragraph={false} active />
            </div>
            : (<>
              {
                listagemArquivos.ListFilesMoveTo.BreadCrumbItem?.PreviousItem
                  ? (<span
                    className="backButton"
                    onClick={() =>
                      searchFolder(String(listagemArquivos.ListFilesMoveTo.BreadCrumbItem?.PreviousItem?.Identifier),
                        listagemArquivos.ListFilesMoveTo.BreadCrumbItem?.PreviousItem?.PreviousItem?.BreadCrumbItemId ||
                        listagemArquivos.ListFilesMoveTo.BreadCrumbItem?.PreviousItem?.PreviousItem?.BreadCrumbItemIdDropbox)
                    }>
                    <Icon icon='voltar' color='branco' customSize={11} />
                  </span>)
                  : ''
              }

              <span className="titleCurrentFolder">
                {listagemArquivos.ListFilesMoveTo.BreadCrumbItem?.Name}
              </span>
            </>)
        }
        <span className="closeButton" onClick={toggleDropdown}>
          <Icon icon='error' color='branco' customSize={18} />
        </span>
      </div>
      <div className="body">
        {
          listagemArquivos.ListFilesMoveTo.isLoading
            ? <div className="skeletonFiles" >
              <Skeleton paragraph={{ rows: 10, width: '50px' }} active />
            </div>
            : listagemArquivos.ListFilesMoveTo.ListFiles?.map((folder) => (
              <div className="folderItem" onClick={() => searchFolder(String(folder.Identifier.ApiId),
                listagemArquivos.ListFilesMoveTo.BreadCrumbItem?.BreadCrumbItemId ||
                listagemArquivos.ListFilesMoveTo.BreadCrumbItem?.BreadCrumbItemIdDropbox)}>
                <Icon icon='arquivar' color='cinzaPadrao' customSize={15} />
                <span className="titleFolderItem" >
                  {folder.Name}
                </span>
              </div>
            ))
        }
      </div>
      <div
        className="footer"
        onClick={moveFiles}>
        <span className={`${'moveFileButton'}
          ${(listagemArquivos.BreadCrumbItem.Identifier
            === listagemArquivos.ListFilesMoveTo.BreadCrumbItem?.Identifier)
            || listagemArquivos.ListFilesMoveTo.isLoading
            ? 'disabled'
            : ''}`}
        >
          Mover aqui
        </span>
      </div>
    </Container>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  listagemArquivos: state.listagemArquivos,
  constructionSiteId: state.listagemArquivos.Obra.ConstructionSiteId,
});

const connector = connect(
  mapState,
);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & IMoverArquivos;

export default connector(MoverArquivos);
